import {
  selectCapitalToast,
  selectIsCapitalToastOpen,
  selectIsContextMenuOpen,
  selectIsModalOpen,
  selectIsToastOpen,
  selectToast
} from '@opengov/component-library-classic/module/view/selectors';
import { viewActionCreators } from '@opengov/component-library-classic/module/view/viewState';

import { isEntitySwitcherOpen } from '../entity/selectors';
import { selectSevereSplashProps } from '../errors/selectors';
import {
  selectAdminBarProps,
  selectEntitySwitcherProps,
  selectNavigationBarProps,
  selectShowGlobalNavBar,
  selectGlobalNavBarProps,
  selectShouldShowCoABanner
} from '../navigation/selectors';
import { canCreateEntity, canSwitchEntities } from '../session/selectors';

export const defaultPageSelectors = {
  adminBarProps: selectAdminBarProps,
  canCreateEntity: canCreateEntity,
  entitySwitcherProps: selectEntitySwitcherProps,
  isToastOpen: selectIsToastOpen,
  isCapitalToastOpen: selectIsCapitalToastOpen,
  navigationBarProps: selectNavigationBarProps,
  globalNavBarProps: selectGlobalNavBarProps,
  severeErrorSplash: selectSevereSplashProps,
  shouldShowAdminBar: canSwitchEntities,
  shouldShowEntitySwitcher: isEntitySwitcherOpen,
  shouldShowModal: selectIsModalOpen,
  shouldShowGlobalNavBar: selectShowGlobalNavBar,
  showContextMenu: selectIsContextMenuOpen,
  toast: selectToast,
  capitalToast: selectCapitalToast,
  hideToast: () => viewActionCreators.hideToast,
  hideCapitalToast: () => viewActionCreators.hideCapitalToast,
  viewElementsOnClick: () => viewActionCreators.documentClicked,
  shouldShowCoABanner: selectShouldShowCoABanner
};
